/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState } from 'react'
import { Modal, Checkbox, Row, Col } from 'antd'
import { visibleColumns } from './utils'

const ColumnSelectModal = ({
  columnHeaders = [],
  hide,
  profile,
  setProfile,
}) => {
  const [selectedCols, setSelectedCols] = useState(
    visibleColumns(profile, columnHeaders).map(col => col.id)
  )

  const onOk = () => {
    // setHiddenColumns()
    setProfile({
      ...profile,
      hiddenColumns: columnHeaders
        .map(col => col.id)
        .filter(colId => !selectedCols.includes(colId))
        .join(','),
    })
    hide()
  }

  const selectAllClicked = e => {
    if (e.target.checked) {
      setSelectedCols(columnHeaders.map(c => c.id))
    } else {
      setSelectedCols([])
    }
  }

  return (
    <Modal
      title="Select Column"
      width="45vw"
      visible
      onOk={onOk}
      okText="Ok"
      onCancel={hide}
      centered
      maskClosable={false}
    >
      <div
        css={{
          marginBottom: 10,
          paddingBottom: 5,
          borderBottom: '1px lightgrey solid',
        }}
      >
        <Checkbox
          checked={selectedCols.length === columnHeaders.length}
          onChange={selectAllClicked}
        >
          Select All
        </Checkbox>
      </div>
      <Checkbox.Group
        value={selectedCols}
        style={{ width: '100%' }}
        onChange={values => setSelectedCols(values)}
      >
        <Row>
          {columnHeaders &&
            columnHeaders.map(col => {
              return (
                <Col key={col.id} span={6} css={{ marginBottom: 10 }}>
                  <Checkbox value={col.id}>{col.display || col.id}</Checkbox>
                </Col>
              )
            })}
        </Row>
      </Checkbox.Group>
    </Modal>
  )
}

export default ColumnSelectModal
